import React, { useContext } from "react";
import Card from "../components/UI/Card";
import AuthContext from "../store/auth-context";
import classes from "./Admin.module.css";

const Admin = () => {
  const AuthCtx = useContext(AuthContext);

  return (
    <Card>
      <h1 className={classes.admin} onClick={AuthCtx.onLogout}>
        Admin
      </h1>
      <p>
        Bij een jaarverbruik van 1200 m3 gas geldt dan een vaste prijs van 1,45
        euro per kubieke meter. Bij een verbruik van 2900 kWh geldt een prijs
        van 0,40 euro per kilowattuur. Bij het stroomverbruik was in eerdere
        plannen nog sprake van een plafond van 2400 kWh, zo schrijft RTL. Deze
        aanpassing is gunstig voor huishoudens. De vaste prijzen voor stroom en
        gas waren in eerdere plannen 1,50 euro per m3 gas, en 0,70 per kWh
        stroom, en zijn dus gedaald. <br/>Boven dit energieplafond geldt straks nog
        de gewone marktprijs. Die verschilt ver aanbieder en contract, en zal
        nog altijd flink hoger zijn. Het kabinet verrekent de korting zelf met
        de energiebedrijven, en huishoudens hoeven hier niets voor te doen.
      </p>
    </Card>
  );
};

export default Admin;